<div class="modal-item" (click)="onModelSelect()" [ngClass]="isSelected ? 'selected-bim-item' : ''">

    <ng-container *ngIf="loading; else contentTemplate">
        <div class="bim-model-item-image">
            <mydocma-loader class="loader" [size]="'extraSmall'">
            </mydocma-loader>
        </div>
    </ng-container>

    <ng-template #contentTemplate>
        <img *ngIf="bimImg$ | async as bimImg; else noImageTemplate" [src]="bimImg" alt="{{ bimModel?.name }}"
            class="bim-model-item-image" width="32" height="32">
    </ng-template>

    <ng-template #noImageTemplate>
        <div class="bim-model-item-image">
        </div>
    </ng-template>

    <div class="modal-item-desc">
        <p class="bim-model-name">{{ bimModel.name }}</p>
        <p class="bim-model-description"> {{ bimModel.description }}</p>
    </div>
</div>
